<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="multisteps-form">
          <div class="row">
            <div class="mx-auto mt-4 mb-3 col-12 col-lg-8 mb-sm-5">
              <div class="multisteps-form__progress">
                <button
                  class="multisteps-form__progress-btn js-active"
                  type="button"
                  title="Operações"
                  :class="activeStep >= 0 ? activeClass : ''"
                  @click="activeStep = 0"
                >
                  <span>Operações</span>
                </button>
                <button
                  class="multisteps-form__progress-btn"
                  type="button"
                  title="Media"
                  :class="activeStep >= 1 ? activeClass : ''"
                  @click="activeStep = 1"
                >
                  Veículos
                </button>
                <button
                  class="multisteps-form__progress-btn"
                  type="button"
                  title="Socials"
                  :class="activeStep >= 2 ? activeClass : ''"
                  @click="activeStep = 2"
                >
                  Configuração
                </button>
                <button
                  class="multisteps-form__progress-btn"
                  type="button"
                  title="Pricing"
                  :class="activeStep >= 3 ? activeClass : ''"
                  @click="activeStep = 3"
                >
                  Finalização
                </button>
              </div>
            </div>
          </div>
          <!--form panels-->
          <div class="row">
            <div class="m-auto col-12 col-lg-8">
              <div class="mb-8 multisteps-form__form">
                <!--single form panel-->
                <Operacoes :operacoes="operacoes" :class="activeStep === 0 ? activeClass : ''" />
                <!--single form panel-->
                <Veiculos :veiculos="veiculos" :class="activeStep === 1 ? activeClass : ''" />
                <!--single form panel-->
                <Configuracao  :configuracao="configuracao" :class="activeStep === 2 ? activeClass : ''" />
                <!--single form panel-->
                <Finalizacao :sincronizar="sincronizar" :class="activeStep === 3 ? activeClass : ''" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Operacoes from "./components/Operacoes.vue";
import Veiculos from "./components/Veiculos.vue";
import Configuracao from "./components/Configuracao.vue";
import Finalizacao from "./components/Finalizacao.vue";

import Pricing from "./components/Pricing.vue";

import fintailapi from "@/api";

const { v4: uuidv4 } = require('uuid');


export default {
  name: "ProfileOverview",
  components: {
    Operacoes,
    Veiculos,
    Configuracao,
    Finalizacao,
    Pricing,
  },
  data() {
    return {
      showMenu: false,
      operacoes:[],
      veiculos:[],
      activeClass: "js-active position-relative",
      activeStep: 0,
      formSteps: 3,
      sincronizar: { show:false, progress:0 },
      configuracao: { ordenar:false, horarios:true, distancia:true, recriar: false, acumular : false}
    };
  },
  mounted() {
    this. getOperacoes();
    
  },
  beforeMount() {

  },
  beforeUnmount() {


  },
  methods: {
    getOperacoes() {

        fintailapi
        .get(`/operacoes?offset=0&limit=100`)
        .then((response) => {

          this.operacoes = response.data.rows
        
        })
        .catch((error) => {

        })

    },
    getVeiculos() {

      let operacoes_ativas = this.operacoes.filter(operacao=> operacao.ativo).map(operacao=> operacao.id) 

      fintailapi
      .post(`/veiculos/operacao`, operacoes_ativas)
      .then((response) => {

        this.veiculos = response.data

      })
      .catch((error) => {

      })

    },
    doCheckSync() {
      fintailapi
        .get(`/rotas/check/${this.sincronizar.uuid}`)
        .then((response) => {
          this.sincronizar.progress = response.data.progresso;
          if (response.data && response.data.status === 'completo') {
            
            this.sincronizar.text = response.data.text;
            this.sincronizar.show = false;
            this.$router.push('/rotas/gerencia');

          }else if (response.data && response.data.status === 'falha') {
            
            this.sincronizar.text  = response.data.mensagem;
            this.sincronizar.show  = false;
            this.sincronizar.error = response.data.mensagem;
            //this.getPedidos(0)

          } else {
            setTimeout(() => {
              this.doCheckSync();
            }, 5000); // Verifica novamente após 5 segundos
          }
        })
        .catch((error) => {
          this.sincronizar.show = false;
          this.sincronizar.error = error.message;
        });
    },
    doCreateRoutes() {

      let operacoes_ativas = this.operacoes.filter(operacao=> operacao.ativo).map(operacao=> operacao.id) 

      let veiculos_ativos = this.veiculos.filter(operacao=> operacao.ativo).map(operacao=> operacao.id) 

      this.sincronizar.uuid = uuidv4();

      fintailapi
      .post(`/rotas/sincronizar`, {id_operacoes: operacoes_ativas, id_veiculos: veiculos_ativos, uuid: this.sincronizar.uuid, configuracao: this.configuracao  })
      .then((response) => {

        this.sincronizar.show = true;
        this.sincronizar.progress = 10;
        this.doCheckSync();

      })
      .catch((error) => {

      })

    },    
    nextStep() {
      if (this.activeStep < this.formSteps) {
        this.activeStep += 1;
      } else {
        this.activeStep -= 1;
      }
      
      if(this.activeStep==1 &&  this.veiculos.length == 0 ){
        this.getVeiculos();
      }

    },
    prevStep() {
      if (this.activeStep > 0) {
        this.activeStep -= 1;
      }
    },
    finishStep() {
      this.doCreateRoutes()
    },
  },
};

</script>
